/* eslint-disable */
import React from 'react'
import Select from 'react-select'
import {Link} from 'react-router-dom'
import http from '../../Component/Interceptor/Interseptor'
import {grid, gridColumn, gridToolbar} from '@progress/kendo-react-excel-export'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import Loader from '../loaders/loader'

class HeaderTable extends React.Component {
  constructor(props) {
    super(props)
    if (this.props.sort) {
      var sort = this.props.sortParams
      for (let i = 0; i < sort.length; i++) {
        sort[i]['label'] = sort[i].title
      }
    }

    this.state = {
      exportExcel: [],
      result: [],
      sortModal: false,
      sortArray: [],
      sortOption: sort,
      sortQueryString: '',
      sortTest: [],
      loading: false
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.sortParams !== this.props.sortParams) {
      this.setState({
        sortTest: this.props.sortParams
      })
    }
  }

  viewRowTable() {
    sessionStorage.setItem('pageNumber', '1')
    let pageNumber = sessionStorage.getItem('pageNumber')

    const {url} = this.props
    let dropDownVal = document.getElementById('dropDownVal').value
    sessionStorage.setItem('dropDownVal', dropDownVal)
    if (this.props.deliveryPackParams) {
      var params = localStorage.getItem('deliveryPackParams')
    } else {
      var params = sessionStorage.getItem('params')
    }

    this.setState({
      loading: true
    })

    const extraParams = this.props.extraParams ? this.props.extraParams : ''

    http
      .get(
        `${url}?export=false&pageNumber=${pageNumber}&pageSize=${dropDownVal}&${params}&${
          this.props.sortResult ? this.props.sortResult : 'sortBy=' + sessionStorage.getItem('sortBy')
        }${extraParams}`,
        {}
      )
      .then((response) => {
        this.setState({
          loading: false
        })
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.props.ChangeDropDown(response.data.object.result)
          this.setState({
            result: response.data.object.result
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  sortTable = (e) => {
    let sortValue = e.target.value
    const {url} = this.props
    let pageSize = sessionStorage.getItem('dropDownVal')
    let pageNumber = sessionStorage.getItem('pageNumber')
    let params = sessionStorage.getItem('params')
    sessionStorage.setItem('sortBy', sortValue)

    http
      .get(`${url}?export=false&pageNumber=${pageNumber}&pageSize=${pageSize}&${params}&sortBy=${sortValue}`, {})
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.props.changeSort(response.data.object.result)
          this.setState({
            result: response.data.object.result
          })
        }
      })
  }

  openSort = () => {
    this.setState({
      sortModal: !this.state.sortModal
    })
  }

  sortFunction = (sortBy, sortLabel) => {
    let {url} = this.props
    let pageSize = sessionStorage.getItem('dropDownVal')
    let pageNumber = sessionStorage.getItem('pageNumber')
    let params = sessionStorage.getItem('params')
    http
      .get(`${url}?export=false&pageNumber=${pageNumber}&pageSize=${pageSize}&${params}&sortBy=${sortBy}`, {})
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.props.changeSort(response.data.object.result, sortLabel)
          this.setState({
            result: response.data.object.result
          })
          this.openSort()
        }
      })
  }

  sortOk = () => {
    sessionStorage.setItem('sortBy', this.state.sortQueryString)
    this.sortFunction(this.state.sortQueryString, this.state.sortLabelArray)
  }

  sortToggle = () => {
    this.setState({
      sortModal: !this.state.sortModal
    })
  }

  sortCancel = () => {
    this.sortToggle()
  }

  handleChangeSort = (sortArray) => {
    this.setState({
      sortArray
    })
    if (sortArray.length == '0') {
      this.setState({
        sortValueArray: [],
        sortLabelArray: [],
        sortQueryString: ''
      })
    } else {
      var sortValue = []
      var sortLabel = []
      for (let prop of sortArray) {
        sortValue.push(prop.value)
        sortLabel.push(prop.label)
        this.setState({
          sortValueArray: sortValue,
          sortLabelArray: sortLabel,
          sortQueryString: sortValue.join()
        })
      }
    }
  }

  render() {
    const {addUrl, selectStatus, printUrl, printLink, disablePageSize} = this.props
    let {sortArray} = this.state

    return (
      <React.Fragment>
        <Loader show={this.state.loading} />

        <div className="optionButtons">
          <select
            className={disablePageSize ? 'd-none' : 'd-inline-block'}
            style={selectStatus == false ? {visibility: 'hidden'} : {visibility: 'visible'}}
            id="dropDownVal"
            onChange={this.viewRowTable.bind(this)}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200" selected={this.props.defaultValuePageSize === '200' ? true : false}>
              200
            </option>
          </select>

          {addUrl && (
            <div id="addWrapper" style={addUrl == '' ? {display: 'none'} : {display: 'inline-block'}}>
              <Link to={addUrl} id="addBaseInfo">
                افزودن
              </Link>
            </div>
          )}

          {this.props.sort ? (
            <div className={this.props.sort ? 'showSortWrapp' : 'hideSortWrapp'}>
              <button className="printButton" title="مرتب سازی" onClick={this.openSort}>
                <i className="fa fa-sort" />
              </button>
            </div>
          ) : (
            ''
          )}
          {printUrl && (
            <Link
              to={printUrl}
              class="printLink"
              target="_blank"
              style={printLink == '' ? {display: 'none'} : {display: 'inline-block'}}
            >
              <span>{this.props.subDispatch ? 'چاپ توزیع' : 'چاپ فاکتور ها'}</span>
            </Link>
          )}
        </div>

        <Modal isOpen={this.state.sortModal} toggle={this.sortToggle} size="sm">
          <ModalHeader toggle={this.sortToggle}>مرتب سازی</ModalHeader>
          <ModalBody>
            <div className="modalForm">
              <div className="formComponent">
                <label>مرتب سازی بر اساس</label>

                <Select
                  value={sortArray}
                  onChange={this.handleChangeSort}
                  options={this.state.sortTest}
                  isMulti={true}
                  isClearable={true}
                  placeholder={'------'}
                />

                {/*<select className='form-control' onChange={this.sortTable} title={'مرتب سازی بر اساس'}>*/}

                {/*<option value=''>------</option>*/}
                {/*{this.state.sortTest.map((item,index)=>(*/}
                {/*<option key={'option'+ index } value={item.value}>{item.label}</option>*/}
                {/*))}*/}
                {/*</select>*/}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.sortOk}>
              مرتب سازی
            </button>
            <button className="cancelBtnModal" onClick={this.sortCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    )
  }
}

export default HeaderTable
